<template>
  <div class="c-panel u-mrgn-top--4">
    <div class="c-panel__body">
      <div class="u-txt--bold u-txt--fair">
        {{ title }}
        <span v-if="otherName" class="u-txt--italic u-txt--normal">({{ otherName }})</span>
      </div>
      <div class="o-layout u-mrgn-top--2 equal-height-container">
        <div class="o-layout__item u-7of12 u-pad-right--2 u-txt--base equal-height-child">
          <EllipsisText class="u-mrgn-bottom--2" :lineNum=2 :message="desc" :expandLink="false" />
          <a :href="link" data-no-turbolink="true" class="u-fg--red-brand u-5of12">Selengkapnya</a>
        </div>
        <div class="o-layout__item u-5of12 u-txt--base u-border--left u-border--ash-light equal-height-child">
          <div class="o-layout__item u-5of12 u-pad-left--2 u-fg--ash-dark">
            <div class="u-width-1 u-mrgn-bottom--1" v-for="(index,i) in infoTitle.length" :key="i">{{ infoTitle[i] }}</div>
          </div>
          <div class="o-layout__item u-6of12">
            <div class="u-width-1 u-mrgn-bottom--1" v-for="(index,i) in infoData.length" :key="i">{{ infoData[i] }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EllipsisText from 'shared/components/Ellipsis/EllipsisText';

export default {
  name: 'GeneralItem',
  components: {
    EllipsisText
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    desc: {
      type: String,
      default: ""
    },
    link: {
      type: String,
      default: ""
    },
    infoTitle: {
      type: Array,
      default: () => []
    },
    infoData: {
      type: Array,
      default: () => []
    },
    otherName: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.equal-height-container {
  display: flex;
}
.equal-height-child {
  flex: 1;
}
</style>

